// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".54c5d86bffc81472ea55a7b2524076467c4848f7.chunk.js";
};